<template>
  <div class="page-sidebar custom-scrollbar original-position page-sidebar-open"
       style="overflow-x:visible;overflow-y: scroll;width:200px">

    <div class="sidebar-user text-center"
         style="padding-bottom:5px">
      <div>
        <img :src="$store.state.logoImageUrl"
             onerror="this.src='https://www.mit4mit.co.il/img/biz_placeHolder.png'"
             style="max-width:100%;min-width:130px;height:130px;border-radius:6px;">
        <br>
        <br>
      </div>
    </div>

    <ul class="sideNav">

      <li>
        <div class="sideNavBizName">

          {{ $store.state.businessSettings.bizName }}

        </div>
      </li>





      <template v-if="$store.getters.getUser.type == 1">

        <li>
          <router-link to="/users/add"
                       class="btn btn-primary sideNavNewButton">
            <svg class="sideNavNewIcon"
                 viewBox="0 0 24 24"
                 aria-hidden="true"
                 v-html="icons['user-plus']"></svg>
            הוסף משתמש
          </router-link>
        </li>

        <li v-for="link in rootAdminLinks"
            :key="link.name">
          <router-link :to="link.route"
                       class="sideNavLink"
                       :class="{ sideNavLink_active: activeName == link.name }">
            <svg class="sideNavIcon"
                 viewBox="0 0 24 24"
                 aria-hidden="true"
                 v-html="icons[link.icon]"></svg>
            <span class="sideNavText">{{ link.label }}</span>
            <span v-if="link.name == 'rootSupport' && supportAdminUnread > 0"
                  class="notification-badge sideNavBadge">{{ supportAdminUnread }}</span>
          </router-link>
        </li>

      </template>





      <li>
        <div style="position:relative;right:0;top:15px;z-index:5;">
          <div id="sidemMenuAddNewMenu"
               style="width:150px;"
               class="addNewMenu card popupMenuToHideOrNot">


            <div v-if="false && $route.name == 'CustomerPage'">

              <div class="addNewMenu_Item"
                   @click="$root.$emit('hideSidebarIfMobile') && $root.$emit('addEventToThisCustomer')">
                <span style="width:15px;text-align: center;display:inline-block">

                  <i class="fa-regular fa-calendar"></i>
                </span>
                &nbsp;
                הוספת אירוע
                <span style="float:left;color:rgb(119,119,119);transform-origin:center;transform:scale(0.9)">
                  לקוח
                  {{ $router.currentRoute.params.id }}
                </span>
              </div>

              <div class="addNewMenu_Item"
                   @click="$root.$emit('hideSidebarIfMobile') && $root.$emit('addMeetingToThisCustomer')">
                <span style="width:15px;text-align: center;display:inline-block">

                  <i class="fa-regular fa-handshake"></i>
                </span>
                &nbsp;
                הוספת פגישה
                <span style="float:left;color:rgb(119,119,119);transform-origin:center;transform:scale(0.9)">
                  לקוח
                  {{ $router.currentRoute.params.id }}
                </span>
              </div>

              <div class="addNewMenu_Item"
                   @click="$root.$emit('hideSidebarIfMobile') && $root.$emit('addTaskToThisCustomer')">
                <span style="width:15px;text-align: center;display:inline-block">
                  <i class="fa-solid fa-bullseye"></i>
                </span>
                &nbsp;
                הוספת משימה
                <span style="float:left;color:rgb(119,119,119);transform-origin:center;transform:scale(0.9)">
                  לקוח
                  {{ $router.currentRoute.params.id }}
                </span>
              </div>




              <div style="border-bottom: solid 1px #d5d5d5;margin-bottom:1px;">

              </div>
            </div>





            <!-- <div @click="$emit('hideSidebarIfMobile') && $router.push('/customer')"
            
                         class="addNewMenu_Item">

              <span style="width:15px;text-align: center;display:inline-block" @click="$root.$emit('hideSidebarIfMobile')">
                <i class="fa-regular fa-user"></i>
              </span>

              &nbsp;
              הוספת לקוח




            </div> -->

            <div v-if="false"
                 @click="$handlers.customerHandler.goToAddCustomerOnlyContacts()"
                 class="addNewMenu_Item">
              <span style="width:15px;text-align: center;display:inline-block">
                <i class="fa-regular fa-user"></i>
              </span>

              &nbsp;
              הוספת לקוח
              (ישן)



            </div>




            <div class="addNewMenu_Item"
                 @click="$root.$emit('hideSidebarIfMobile') && $root.$emit('openTargetForNewEntityModal', 'event')">
              <span style="width:15px;text-align: center;display:inline-block">

                <i class="fa-regular fa-calendar"></i>
              </span>
              &nbsp;
              הוספת פניה
            </div>

            <div class="addNewMenu_Item"
                 @click="$emit('hideSidebarIfMobile') && $root.$emit('openTargetForNewEntityModal', 'meeting')">
              <span style="width:15px;text-align: center;display:inline-block">

                <i class="fa-regular fa-handshake"></i>
              </span>
              &nbsp;
              הוספת פגישה
            </div>


            <div v-if="false"
                 class="addNewMenu_Item">
              <span style="width:15px;text-align: center;display:inline-block">

                <i class="fa-regular fa-calendar"></i>
              </span>
              &nbsp;
              הוספת אירוע

              <i class="fa fa-angle-left"
                 style="float:left;position:relative;top:4px;"></i>

              <div class="addNewMenu_subMenu card">
                <div @click="$emit('hideSidebarIfMobile') && $handlers.customerHandler.goToAddCustomerAddEvent()"
                     class="addNewMenu_Item">
                  <i class="fa-solid fa-user-plus"></i>
                  &nbsp;
                  לקוח חדש
                </div>
                <div class="addNewMenu_Item"
                     @click="$emit('hideSidebarIfMobile') && $root.$emit('findCustomer', $handlers.eventHandler.gotoAddNewEventToCustomerFromSearchResult)">
                  <i class="fa-solid fa-user-group"></i>
                  &nbsp;
                  לקוח קיים
                </div>

              </div>
            </div>








            <div v-if="false"
                 class="addNewMenu_Item">
              <span style="width:15px;text-align: center;display:inline-block">

                <i class="fa-regular fa-handshake"></i>
              </span>
              &nbsp;
              הוספת פגישה
              <i class="fa fa-angle-left"
                 style="float:left;position:relative;top:4px;"></i>

              <div class="addNewMenu_subMenu card">
                <div @click="$handlers.customerHandler.goToAddCustomerOnlyMeeting()"
                     class="addNewMenu_Item">
                  <i class="fa-solid fa-user-plus"></i>
                  &nbsp;
                  לקוח חדש
                </div>
                <div class="addNewMenu_Item"
                     @click="$root.$emit('findCustomer', $handlers.meetingHandler.gotoAddNewMeetingFromSearch)">
                  <i class="fa-solid fa-user-group"></i>
                  &nbsp;
                  לקוח קיים
                </div>

              </div>

            </div>


            <div @click="$root.$emit('openTargetForNewEntityModal', 'task')"
                 class="addNewMenu_Item">
              <span style="width:15px;text-align: center;display:inline-block">
                <i class="fa-solid fa-bullseye"></i>
              </span>
              &nbsp;
              הוספת משימה
            </div>

            <!-- אישי: a block of time on the calendar with no customer behind it (מילואים, רופא...) -->
            <div @click="$emit('hideSidebarIfMobile') && $root.$emit('openPersonalItemModal')"
                 class="addNewMenu_Item"
                 data-add-personal-item>
              <span style="width:15px;text-align: center;display:inline-block">
                <i class="fa-solid fa-user-clock"></i>
              </span>
              &nbsp;
              הוספת פריט אישי
            </div>

            <router-link v-if="false"
                         to="/documents"
                         class="addNewMenu_Item">
              <span style="width:15px;text-align: center;display:inline-block">
                <i class="fa-regular fa-file"></i>
              </span>
              &nbsp;
              הוספת מסמך
            </router-link>


            <div class="addNewMenu_Item">
              <span style="width:15px;text-align: center;display:inline-block">

                <i class="fa-solid fa-receipt"></i>

              </span>
              &nbsp;
              מסמך חשבונאי
              <i class="fa fa-angle-left"
                 style="float:left;position:relative;top:4px;"></i>

              <div class="addNewMenu_subMenu card"
                   style="padding-top:0;margin-right:-120px;padding-right:80px;width:140px;">

                <div class="addNewMenu card"
                     style="padding-top:0;top:-5px;right:1px">

                  <span style="color:black"
                        v-for="taxDocumentType in $store.state.taxDocumentTypes"
                        v-bind:key="taxDocumentType.value"
                        @click="$root.$emit('openTargetForNewEntityModal', 'taxDocument', { taxDocumentType })"
                        class="addNewMenu_Item">
                    &nbsp;
                    {{ taxDocumentType.name }}
                  </span>


                </div>


              </div>

            </div>


          </div>











        </div>






        <div onclick="document.querySelector('#sidemMenuAddNewMenu').classList.add('popupMenuToHideOrNot_showMenu')"
             v-if="$store.getters.getUser.type != 1"
             id="addNewMenuButton"
             class="btn btn-primary popupMenuToHideOrNot_openerButton sideNavNewButton">
          <svg class="sideNavNewIcon"
               viewBox="0 0 24 24"
               aria-hidden="true"
               v-html="icons.plus"></svg>
          <span style="pointer-events:none">חדש</span>
        </div>


      </li>
      <!-- the sections (menu_for_biz.js 'group'): a title + a line above each one but the first -->
      <template v-for="group in menuGroups">

        <li v-if="group.key != 'main'"
            :key="'group-' + group.key"
            class="sideNavGroupTitle">
          <span>{{ $t("menuGroup_" + group.key) }}</span>
        </li>

        <li v-for="menu in group.items"
            :key="menu.name"
            :class="{ sideNavEntry_open: isSubMenuOpen(menu) }">

          <router-link v-if="!menu.subMenu"
                       :to="menu.route"
                       class="sideNavLink"
                       :class="{ sideNavLink_active: activeName == menu.name }"
                       @click.native="$emit('hideSidebarIfMobile')">
            <svg class="sideNavIcon"
                 viewBox="0 0 24 24"
                 aria-hidden="true"
                 v-html="icons[menu.icon]"></svg>
            <span class="sideNavText">{{ $t("menu_" + menu.name) }}</span>
          </router-link>

          <a v-if="menu.subMenu"
             href="javascript:void(0)"
             class="sideNavLink"
             :class="{ sideNavLink_activeInside: hasActiveSubMenu(menu) }"
             :aria-expanded="isSubMenuOpen(menu) ? 'true' : 'false'"
             @click="toggleSubMenu(menu)">
            <svg class="sideNavIcon"
                 viewBox="0 0 24 24"
                 aria-hidden="true"
                 v-html="icons[menu.icon]"></svg>
            <span class="sideNavText">{{ $t("menu_" + menu.name) }}</span>
            <svg class="sideNavChevron"
                 viewBox="0 0 24 24"
                 aria-hidden="true"
                 v-html="icons['chevron-down']"></svg>
          </a>

          <ul v-if="menu.subMenu"
              v-show="isSubMenuOpen(menu)"
              class="sidebar-submenu sideNavSub">

            <li v-for="subMenu in menu.subMenu"
                :key="subMenu.name">
              <router-link :to="subMenu.route"
                           class="sideNavSubLink"
                           :class="{ sideNavLink_active: activeName == subMenu.name }"
                           @click.native="$emit('hideSidebarIfMobile')">
                {{ $t("menu_" + subMenu.name) }}
              </router-link>
            </li>

          </ul>

        </li>

      </template>

      <li class="sideNavDivider"></li>

      <li>
        <a href="javascript:void(0)"
           class="sideNavLink sideNavLink_quiet"
           @click="logOff">
          <svg class="sideNavIcon"
               viewBox="0 0 24 24"
               aria-hidden="true"
               v-html="icons['log-out']"></svg>
          <span class="sideNavText">{{ $t('logoff') }}</span>
        </a>
      </li>


      <li>
        <div class="sideNavTenantId">

          {{ $store.state.tenantId === "default" ? "" : $store.state.tenantId }}

        </div>

      </li>

    </ul>




    <br>





  </div>
</template>

<script>
import Role from '../../core/auth/roles.enum';
import axiosV2 from "../../core/http/axios_api_v2";
import { featureDisabled } from "@/core/acl/features";
import MenuForBiz from "@/core/menu/menu_for_biz";
import MenuForAdmin from "@/core/menu/menu_for_admin";
import MenuIcons from "@/core/menu/menu_icons";
import hasPermission from "@/core/acl/acl";

export default {
  name: "SideMenu",
  data() {
    return {
      //businesses with support questions the root admin hasn't opened yet (polled - the root
      //admin has no socket)
      supportAdminUnread: 0,
      supportAdminUnreadTimer: null,

      //name of a menu with a subMenu -> open / closed, once the user clicked it (until then it
      //is open only while one of its pages is the current one)
      subMenuOpen: {},
    }
  },

  watch: {

    //arriving at a page of a closed subMenu (a link elsewhere in the app) opens it again
    activeName() {
      (this.PlanupMenu || []).forEach(menu => {
        if (this.hasActiveSubMenu(menu))
          this.$delete(this.subMenuOpen, menu.name);
      });
    },

    //the user reaches the store after this menu mounts (appData), so the poll keys on it
    '$store.state.user': {
      immediate: true,
      handler(user) {

        clearInterval(this.supportAdminUnreadTimer);
        this.supportAdminUnreadTimer = null;

        if (!user || user.type != 1)
          return;

        this.refreshSupportAdminUnread();
        this.supportAdminUnreadTimer = setInterval(this.refreshSupportAdminUnread, 60000);

      }
    },

  },

  beforeDestroy() {
    clearInterval(this.supportAdminUnreadTimer);
  },


  methods: {

    hasActiveSubMenu(menu) {
      return !!menu.subMenu && menu.subMenu.some(subMenu => subMenu.name == this.activeName);
    },

    isSubMenuOpen(menu) {
      if (!menu.subMenu)
        return false;
      let clicked = this.subMenuOpen[menu.name];
      return clicked === undefined ? this.hasActiveSubMenu(menu) : clicked;
    },

    toggleSubMenu(menu) {
      this.$set(this.subMenuOpen, menu.name, !this.isSubMenuOpen(menu));
    },

    refreshSupportAdminUnread() {

      axiosV2('support/admin/unread').then(res => {
        if (res && res.data && typeof res.data.count == 'number')
          this.supportAdminUnread = res.data.count;
      }).catch(() => { });

    },

    logOff() {


      //yonso hardcore logoff instead:
      document.cookie = `token=; path=/;SameSite=strict; Secure;`;
      localStorage.removeItem('tenantId');
      window.location.href = `http://${window.location.host}`;


      //previous logoff

      // this.$store
      //   .dispatch("logoff")
      //   .then((response) => {
      //     this.$router.push("/login");
      //   })
      //   .catch((err) => {
      //     console.warn("Failed to logoff - ", err);
      //     this.$router.replace("/login", function () {
      //       setTimeout(function () {
      //         location.reload();
      //       }, 1000);
      //     });
      //   });
    },


  },


  computed: {

    icons() {
      return MenuIcons;
    },

    //the root admin's menu (user type 1 - no business menu)
    rootAdminLinks() {
      return [
        { name: 'rootTenants', route: '/root-admin/tenants', label: 'משתמשים', icon: 'building-2' },
        { name: 'rootLog', route: '/log', label: 'לוג', icon: 'scroll-text' },
        { name: 'rootClientLeads', route: '/root-admin/client-leads', label: this.$t('clientLeads'), icon: 'inbox' },
        { name: 'rootSignups', route: '/root-admin/signups', label: 'הרשמות עצמאיות', icon: 'user-round-plus' },
        { name: 'rootCoupons', route: '/root-admin/coupons', label: 'קופונים להרשמה', icon: 'ticket-percent' },
        { name: 'rootAi', route: '/root-admin/ai', label: 'עוזר AI', icon: 'sparkles' },
        { name: 'rootSupport', route: '/root-admin/support', label: 'פניות תמיכה', icon: 'headset' },
        { name: 'rootAnnouncements', route: '/root-admin/announcements', label: 'הכרזות', icon: 'megaphone' },
        { name: 'rootEsign', route: '/root-admin/esign', label: 'חתימה דיגיטלית', icon: 'signature' },
      ];
    },

    //the visible menu in sections: consecutive entries of one 'group' (menu_for_biz.js)
    menuGroups() {
      let groups = [];
      (this.PlanupMenu || []).forEach(menu => {
        let key = menu.group || 'main';
        let last = groups[groups.length - 1];
        if (!last || last.key != key) {
          last = { key: key, items: [] };
          groups.push(last);
        }
        last.items.push(menu);
      });
      return groups;
    },

    //the entry of the current page: the one whose route (or match) is the longest path the
    //current one starts with - /settings/homepage lights דף הבית, not הגדרות ארגון too
    activeName() {
      let path = this.$route.path.replace(/\/+$/, '') || '/';
      let entries = [];
      if (this.$store.getters.getUser.type == 1)
        entries = this.rootAdminLinks.slice();
      (this.PlanupMenu || []).forEach(menu => {
        entries = entries.concat(menu.subMenu || [menu]);
      });

      let activeName = null, longest = -1;
      entries.forEach(entry => {
        [].concat(entry.route || [], entry.match || []).forEach(route => {
          route = route.replace(/\/+$/, '') || '/';
          let hit = route == '/' ? path == '/' : (path == route || path.indexOf(route + '/') == 0);
          if (hit && route.length > longest) {
            activeName = entry.name;
            longest = route.length;
          }
        });
      });
      return activeName;
    },

    PlanupMenu() {

      let menu = [];
      let visibleMenu = [];

      switch (this.$store.getters.getUser.type) {

        case Role.Admin:
          visibleMenu = MenuForAdmin;
          return;

        case Role.HallManager:
        case Role.HallManagerChild:
          menu = MenuForBiz;
          break;

      }



      let bizServices = this.$store.getters.getUser.bizServices;

      menu.forEach(menuElement => {



        //for now showing full menu for everybody
        //for now showing full menu for everybody
        //for now showing full menu for everybody
        //for now showing full menu for everybody
        //for now showing full menu for everybody



        if (true || bizServices.includes('' + menuElement.service)) {

          // Opt-in strict service gate (requireService: true): shown only when the SYSTEM admin
          // enabled the service for this account (users.bizServices via root-admin). Unlike the
          // relaxed check above, this one is actually enforced.
          // `service` may be one id or a list (the venue suite: any of its ids opens the page)
          if (menuElement.requireService && ![].concat(menuElement.service).some(id => (bizServices || []).map(String).includes(String(id)))) {
            return;
          }

          // Hide ownerOnly items for HallManagerChild
          if (menuElement.ownerOnly && this.$store.getters.getUser.type == Role.HallManagerChild) {
            return;
          }

          // A module the root admin switched off for this account (appData.disabledFeatures)
          if (menuElement.feature && featureDisabled(this.$store, menuElement.feature)) {
            return;
          }

          // Hide items the user lacks the capability permission for (build spec §4.1)
          if (menuElement.permission && !hasPermission(this.$store.getters.getUser, menuElement.permission)) {
            return;
          }

          // Filter subMenu items if they exist
          if (menuElement.subMenu) {
            let filteredSubMenu = menuElement.subMenu.filter(subMenu => {
              // Strict service gate — same rule as top-level items (system-admin enabled accounts only)
              if (subMenu.requireService && ![].concat(subMenu.service).some(id => (bizServices || []).map(String).includes(String(id)))) {
                return false;
              }
              // Hide foodMenu if showFoodMenu is false
              if (subMenu.name === 'foodMenu' && !this.$store.state.businessSettings?.showFoodMenu) {
                return false;
              }
              // A module the root admin switched off for this account
              if (subMenu.feature && featureDisabled(this.$store, subMenu.feature)) {
                return false;
              }
              // Hide ownerOnly items for HallManagerChild
              if (subMenu.ownerOnly && this.$store.getters.getUser.type == Role.HallManagerChild) {
                return false;
              }
              // Hide submenu items the user lacks the capability permission for (build spec §4.1)
              if (subMenu.permission && !hasPermission(this.$store.getters.getUser, subMenu.permission)) {
                return false;
              }
              return true;
            });
            
            // Only add the menu element if it has visible submenu items
            if (filteredSubMenu.length > 0) {
              visibleMenu.push({
                ...menuElement,
                subMenu: filteredSubMenu
              });
            }
          } else {
            visibleMenu.push(menuElement);
          }
        }

      });

      return visibleMenu;
    },
  },


};
</script>
<style>
.addNewMenu_Item {
  /* border-bottom: solid 1px #dee2e6; */
  padding: 7px 8px;
  cursor: pointer;
  margin: 4px 0;
  position: relative;
  overflow: visible;
  display: block;
}

.addNewMenu_subMenu {
  position: absolute;
  top: 0;
  right: 100%;
  display: none;
  width: 155px;
  background: #f6f7fb;
}

.addNewMenu_subMenu .addNewMenu_Item {
  padding-right: 10px;
}

.addNewMenu_Item:hover .addNewMenu_subMenu {
  display: block;
  z-index: 999;

}

.addNewMenu_Item:hover {
  /* background-color: #ab8ce4; */
  background-color: #e3e3e3;
}


.addNewMenu i {
  color: rgb(119, 119, 119);
}

.addNewMenu {
  top: 0;
  right: 0;
  position: absolute;
  width: 100%;
  padding: 5px 0;
  background: #f6f7fb;
}
</style>
<style>
/* the side menu: sections with a title and a line, an outline icon per entry (menu_icons.js),
   the current page on a light purple background with a bar */

.page-sidebar .sideNav {
  list-style: none;
  margin: 0;
  padding: 0 12px 14px;
  text-align: right;
}

.page-sidebar .sideNav li {
  list-style: none;
}

.sideNavBizName {
  margin-top: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
  color: #4a4a4a;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.page-sidebar .sideNavNewButton {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  height: 40px;
  margin: 15px 0 12px;
  padding: 0 12px;
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: normal;
}

.sideNavNewIcon {
  width: 17px;
  height: 17px;
  flex: none;
  fill: none;
  stroke: currentColor;
  stroke-width: 2.25;
  stroke-linecap: round;
  stroke-linejoin: round;
  pointer-events: none;
}

.page-sidebar .sideNavGroupTitle {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 14px 2px 4px;
  color: #8b90a3;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
}

.sideNavGroupTitle::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #ebebf2;
}

.page-sidebar .sideNavLink {
  position: relative;
  display: flex;
  align-items: center;
  gap: 11px;
  min-height: 36px;
  margin: 1px 0;
  padding: 7px 10px;
  border-radius: 8px;
  color: #2a3142;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  text-decoration: none;
  cursor: pointer;
  transition: background-color .15s ease, color .15s ease;
}

.page-sidebar .sideNavLink:hover {
  background: #f5f2fc;
  color: #2a3142;
  text-decoration: none;
}

.page-sidebar .sideNavLink:focus-visible,
.page-sidebar .sideNavSubLink:focus-visible {
  outline: 2px solid #ab8ce4;
  outline-offset: -2px;
}

.sideNavIcon {
  width: 18px;
  height: 18px;
  flex: none;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.75;
  stroke-linecap: round;
  stroke-linejoin: round;
  color: #6b7185;
  transition: color .15s ease;
}

.sideNavLink:hover .sideNavIcon,
.sideNavLink_active .sideNavIcon,
.sideNavLink_activeInside .sideNavIcon {
  color: #7650c4;
}

.sideNavText {
  flex: 1;
  min-width: 0;
}

.page-sidebar .sideNavLink.sideNavLink_active,
.page-sidebar .sideNavLink.sideNavLink_active:hover {
  background: #f1ecfc;
  color: #7650c4;
  font-weight: 600;
}

.sideNavLink_active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 3px;
  border-radius: 3px;
  background: #ab8ce4;
}

.sideNavChevron {
  width: 15px;
  height: 15px;
  flex: none;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  color: #9aa0b4;
  transition: transform .2s ease;
}

.sideNavEntry_open > .sideNavLink .sideNavChevron {
  transform: rotate(180deg);
}

/* a subMenu: indented to the text of its parent, a line under the parent's icon */
.page-sidebar .sideNavSub {
  position: relative;
  list-style: none;
  margin: 2px 0 6px;
  padding: 0 29px 0 0;
}

.sideNavSub::before {
  content: '';
  position: absolute;
  top: 2px;
  bottom: 2px;
  right: 19px;
  width: 1px;
  background: #e7e3f1;
}

.page-sidebar .sideNavSubLink {
  position: relative;
  display: block;
  margin: 1px 0;
  padding: 5px 10px;
  border-radius: 6px;
  color: #50566c;
  font-size: 13px;
  line-height: 1.45;
  text-decoration: none;
  transition: background-color .15s ease, color .15s ease;
}

.page-sidebar .sideNavSubLink:hover {
  background: #f5f2fc;
  color: #2a3142;
  text-decoration: none;
}

.page-sidebar .sideNavSubLink.sideNavLink_active {
  background: #f1ecfc;
  color: #7650c4;
  font-weight: 600;
}

/* the bar of a current subMenu page sits on the line */
.sideNavSubLink.sideNavLink_active::before {
  left: auto;
  right: -11px;
  top: 6px;
  bottom: 6px;
}

.page-sidebar .sideNavDivider {
  height: 1px;
  margin: 12px 2px 6px;
  background: #ebebf2;
}

.page-sidebar .sideNavLink.sideNavLink_quiet {
  color: #6b7185;
}

.page-sidebar .sideNavBadge {
  position: static;
  margin: 0;
}

.sideNavTenantId {
  margin-top: 6px;
  opacity: 0.5;
  text-align: center;
  font-size: 10px;
}
</style>
